import { Icon } from '@fluentui/react';

import { IconName } from '../../../../models/components.models';
import { useClassNames } from '../../../../utils/hooks';
import { TooltipHost } from '../../../TooltipHost/TooltipHost';
import { navigationElementMoreStyles } from './navigationElementMore.styles';
import type {
  NavigationElementMoreClassNames,
  NavigationElementMoreStyles,
  NavigationElementsMoreProps,
} from './types';

export const NavigationElementMore = (props: NavigationElementsMoreProps) => {
  const classNames = useClassNames<NavigationElementMoreStyles, NavigationElementMoreClassNames>(
    'NavigationElementsMore',
    navigationElementMoreStyles
  );

  const moreText = props.more?.text;
  // `more` carries either a short badge (an icon, a count) or free text supplied elsewhere — the
  // sidebar's version row passes whatever the discovery service reports, which can be long. Only
  // textual content is truncated: an icon has no sensible ellipsis and keeps its intrinsic size.
  const isTextual = typeof moreText === 'string' || typeof moreText === 'number';

  return (
    <div className={classNames.root}>
      {moreText &&
        (isTextual ? (
          <TooltipHost content={String(moreText)}>
            <div className={classNames.text}>{moreText}</div>
          </TooltipHost>
        ) : (
          <div>{moreText}</div>
        ))}
      {props.section && <div className={classNames.nestedArrow}>{<Icon iconName={IconName.ChevronRight} />}</div>}
    </div>
  );
};
